"use strict";
/*
 * Created on 07.11.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ChangedWorkflowStateSettings_1 = require("./promo-settings-set/ChangedWorkflowStateSettings");

var CherryPickSettings_1 = require("./promo-settings-set/CherryPickSettings");

var DefaultWindowTypeSettings_1 = require("./promo-settings-set/DefaultWindowTypeSettings");

var ReplenishmentSettings_1 = require("./promo-settings-set/ReplenishmentSettings");

var RoundingRulesSettings_1 = require("./promo-settings-set/RoundingRulesSettings");

var ThresholdSettings_1 = require("./promo-settings-set/ThresholdSettings");
/**
 * Threshold settings entity also stores default window type row for promo and system volume.
 * @author ZSr
 *
 * @param id
 * @param replenishmentSettings
 * @param defaultWindowType
 * @param cherryPickSettings
 * @param changedWorkflowState
 * @param roundingRules
 */


var PromoSettings =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromoSettings, _DomainObject_1$Domai);

  function PromoSettings(id, thresholdSettings, replenishmentSettings, defaultWindowType, cherryPickSettings, changedWorkflowState, roundingRules) {
    var _this;

    _classCallCheck(this, PromoSettings);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoSettings).call(this));
    _this.id = id;
    _this.thresholdSettings = thresholdSettings;
    _this.replenishmentSettings = replenishmentSettings;
    _this.defaultWindowType = defaultWindowType;
    _this.cherryPickSettings = cherryPickSettings;
    _this.changedWorkflowState = changedWorkflowState;
    _this.roundingRules = roundingRules;
    return _this;
  }

  return PromoSettings;
}(DomainObject_1.DomainObject);

exports.PromoSettings = PromoSettings;

PromoSettings.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromoSettings.name);
  return {
    id: builder.id('id'),
    thresholdSettings: builder.obj('thresholdSettings', ThresholdSettings_1.ThresholdSettings.schema, function (mat) {
      return new ThresholdSettings_1.ThresholdSettings(mat.forecastCoordinatorConditionCheckEnabled);
    }),
    replenishmentSettings: builder.obj('replenishmentSettings', ReplenishmentSettings_1.ReplenishmentSettings.schema, function (mat) {
      return new ReplenishmentSettings_1.ReplenishmentSettings(mat.thresholdActivated, mat.thresholdReplenishmentNotification, mat.thresholdReplenishmentNotificationRel);
    }),
    defaultWindowType: builder.obj('defaultWindowType', DefaultWindowTypeSettings_1.DefaultWindowTypeSettings.schema, function (mat) {
      return new DefaultWindowTypeSettings_1.DefaultWindowTypeSettings(mat.name, mat.promoVolumeThresholdRel, mat.promoVolumeThresholdAbs, mat.promoVolumeThresholdEnabled, mat.coordinatorApprovalNeeded, mat.systemVolumeThresholdRel, mat.systemVolumeThresholdAbs, mat.systemVolumeThresholdEnabled);
    }),
    cherryPickSettings: builder.obj('cherryPickSettings', CherryPickSettings_1.CherryPickSettings.schema, function (mat) {
      return new CherryPickSettings_1.CherryPickSettings(mat.cherryPickSettingsStatus, mat.thresholdTransactionSales, mat.thresholdTransactionVolume, mat.thresholdProduct);
    }),
    changedWorkflowState: builder.obj('changedWorkflowState', ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings.schema, function (mat) {
      return new ChangedWorkflowStateSettings_1.ChangedWorkflowStateSettings(mat.overallThresholdsActivated, mat.salesRelTh, mat.salesAbsTh, mat.impactBM2RelTh, mat.impactBM2AbsTh, mat.productThresholdsActivated, mat.promoVolumeRelTh, mat.promoVolumeAbsTh, mat.promoPriceRelTh, mat.promoPriceAbsTh, mat.promoPurchasePriceRelTh, mat.promoPurchasePriceAbsTh, mat.unitBackDiscountRelTh, mat.unitBackDiscountAbsTh);
    }),
    roundingRules: builder.obj('roundingRules', RoundingRulesSettings_1.RoundingRulesSettings.schema, function (mat) {
      return new RoundingRulesSettings_1.RoundingRulesSettings(mat.volumes, mat.prices, mat.percent, mat.kpisPrices);
    })
  };
}();